// context/PermissionsContext.tsx
import React, { createContext, useContext, useState, useEffect } from "react";

const PermissionsContext = createContext<{
  permissions: string[];
  setPermissions: React.Dispatch<React.SetStateAction<string[]>>;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}>({
  permissions: [],
  setPermissions: () => {},
  isLoading: false,
  setIsLoading: () => {},
});

export const PermissionsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [permissions, setPermissions] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  return (
    <PermissionsContext.Provider
      value={{ permissions, setPermissions, isLoading, setIsLoading }}
    >
      {children}
    </PermissionsContext.Provider>
  );
};

// Hook personnalisé pour utiliser le contexte plus facilement
export const usePermissions = () => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error("usePermissions must be used within a PermissionsProvider");
  }
  return context;
};
